interface ISceneScreenshot {
  screenshot: Blob;
  url: string;
}

class ScenesScreenshot {
  private scenes: Map<string, ISceneScreenshot> = new Map();

  async getScene(scene: string) {
    return `eriol-workspace://scenes/${scene}.jpg`;
  }

  async removeScene(scene: string) {
    this.scenes.delete(scene);
  }

  destroy() {
    for (const scene of this.scenes.keys()) {
      this.removeScene(scene);
    }
  }
}

export default new ScenesScreenshot();
